<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage transporters</div>
            <fieldset class="border p-3">
              <div></div>
              <div>
                <div class="transportersLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading transporters...
                </div>

                <vue-good-table
                  :columns="columns"
                  :rows="systemTransporters"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'status'">
                      <span v-if="props.row.status === 0">
                        <button class="btn btn-info btn-sm btn-flat">
                          <i class="fa fa-level-up"></i> Active
                        </button>
                      </span>
                      <span v-else-if="props.row.status === 1">
                        <button class="btn btn-danger btn-sm">
                          <i class="fa fa-level-down"></i>Blacklisted
                        </button>
                      </span>
                    </span>
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                    <span v-if="props.column.field == 'Trucklist'">
                      <button
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="loadTransportertruck(props.row.id)"
                      >
                        <i class="fa fa-file-pdf-o"></i> TRUCK LIST
                      </button>
                    </span>
                    <span v-else-if="props.column.field == 'Edit'">
                      <button
                        v-b-tooltip.hover.bottom="'Edit transporter!'"
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="viewTransporter(props.row.id)"
                      >
                        <i class="fa fa-truck"></i> Edit transporter
                      </button>
                    </span>
                    <span v-else-if="props.column.field == 'Trucks'">
                      <button
                        v-b-tooltip.hover.bottom="'Add trucks!'"
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="viewTransportertruck(props.row.id)"
                      >
                        <i class="fa fa-truck"></i> Add Trucks
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Registration Date",
          field: "reg_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        },
        {
          label: "Transporter Name",
          field: "transporter_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter transporter",
          },
        },
        {
          label: "Email",
          field: "email_address",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter email",
          },
        },
        {
          label: "Mobile",
          field: "mobile_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter mobile number",
          },
        },
        {
          label: "Contact Person",
          field: "contact_person",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter contact person",
          },
        },
        {
          label: "Status",
          field: "status",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter status",
          },
        },
        {
          label: "Truck list",
          field: "Trucklist",
          width: "122px",
          html: true,
        },
        {
          label: "Edit",
          field: "Edit",
          width: "122px",
          html: true,
        },
        {
          label: " Add Truck",
          field: "Trucks",
          width: "122px",
          html: true,
        },
      ],
    };
  },

  created() {
    this.loadTransporters();
  },
  computed: {
    ...mapGetters(["systemTransporters"]),
  },
  methods: {
    ...mapActions([
      "loadTransporters",
      "viewTransporter",
      "viewTransportertruck",
      "loadTransportertruck",
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/transporters/managetransporters.vue